<template>
    <el-select class="my-el-select" v-model="arr" multiple :placeholder="placeholder" style="width: 100%;" @change='selectedChange' size="small">
      <el-option v-for="(item,index) in list" :key="index"  :label="item.label" :value="item.value"></el-option>
    </el-select>
</template>
<script>
export default {
  name: 'XrMultipleSelect',
  props: ['list', 'value', 'placeholder'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      arr: []
    }
  },
  watch: {
    value(newName) {
      this.arr = this.CommonUtils.strToArray(newName);
    },
    list(newName) {

    },
  },
  created() {
    this.$nextTick(()=>{
      this.arr = this.CommonUtils.strToArray(this.value);
    })
  },
  methods: {
    selectedChange(e){
      let value = this.CommonUtils.listToStr(this.arr);
      this.$emit('change', value);
    }
  }
}
</script>

<style lang="scss" scoped>
  /** 按钮样式 */
  .th-button{
    display: inline;
    border: 1px solid #d9d9d9;
    padding: 4px 10px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    color: rgba(0,0,0,.65);
    margin-right: 8px;
  }

  .primary{
    background: #007aff;
    color: #fff;
  }

  .my-el-select {
    .el-input__inner{
      height: 30px;
    }
    /* 下面设置右侧按钮居中 */
    .el-input__suffix {
      top: 5px;
    }
    .el-input__icon {
      line-height: inherit;
    }
    .el-input__suffix-inner {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/XrMultipleSelect/index.vue